export default __webpack_public_path__ + "static/media/why.61830f6b.png";